$(document).ready(function(){
  var page_recent =2
  $('.blog__recent .blog-load-more').click(function(){
    var loadMore=$(this).text();
    var url = window.location.href;
    url += '/tagged/most-recent?page='+page_recent+'&view=pagination';
    page_recent++;
    console.log(url)
    $.ajax({
      type: 'GET',
      url: url,
      dataType: 'html',
      beforeSend: function () {
        $('.blog__recent .blog-load-more').attr('disabled', true);
        $('.blog__recent .blog-load-more').text('Loadding');
      },
      success: function (data) {
        $('.blog-list').append($(data).find('.blog__recent .blog-item').each(function () {
          $(this).html();
        }));
        $('.blog__recent .blog-item').show();
        if($(data).find('.blog__recent .PaginationLink.next').length){
          $('.blog__recent .blog-load-more').attr('disabled', false);
          $('.blog__recent .blog-load-more').text(loadMore);
        }
        else{
          $('.blog__recent .load-more-wrapper').hide();
        }
      },
      complete: function () {
      },
      error: function () {
        console.log('error')
      }
    });

  })
  var page_list =2
  $('.section-blog-list .blog-load-more').click(function(){
    var loadMore=$(this).text();
    var url = window.location.href;
    url += '/?page='+page_list+'&view=pagination';
    page_list++;
    $.ajax({
      type: 'GET',
      url: url,
      dataType: 'html',
      beforeSend: function () {
        $('.section-blog-list .blog-load-more').attr('disabled', true);
        $('.section-blog-list .blog-load-more').text('Loadding');
      },
      success: function (data) {
        $('.blog-listing').append($(data).find('.blog__listing .blog-item').each(function () {
          $(this).html();
        }));
        if($(data).find('.blog__listing .PaginationLink.next').length){
          $('.section-blog-list .blog-load-more').attr('disabled', false);
          $('.section-blog-list .blog-load-more').text(loadMore);
        }
        else{
          $('.section-blog-list .load-more-wrapper').hide();
        }
      },
      complete: function () {
      },
      error: function () {
        console.log('error')
      }
    });

  })
  if($('.sidebar-article-wrapper')){
    const breakpoint = window.matchMedia( '(min-width:767.98px)' );
    let mySwiper;

    const breakpointChecker = function() {

      // if larger viewport and multi-row layout needed
      if ( breakpoint.matches === true ) {

        // clean up old instances and inline styles when available
        if ( mySwiper !== undefined ) mySwiper.destroy( true, true );

        // or/and do nothing
        return;

        // else if a small viewport and single column layout needed
      } else if ( breakpoint.matches === false ) {

        // fire small viewport version of swiper
        return enableSwiper();

      }

    };

    const enableSwiper = function() {

      mySwiper = new Swiper ('.sidebar-article-wrapper', {

        loop: false,

        slidesPerView: 'auto',
        grabCursor: true,

        // pagination
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },

      });

    };

    // keep an eye on viewport size changes
    breakpoint.addListener(breakpointChecker);

    // kickstart
    breakpointChecker();
  }
  if($('.blog-collection-list')){
    var swiperCollection = new Swiper(".blog-collection-list", {
      slidesPerView: 1,
      spaceBetween: 53,
      freeMode: true,
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 30,
          freeMode: false,
        },
        376: {
          slidesPerView: 1,
          spaceBetween: 53,
          freeMode: false,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 40,
          freeMode: true,
        },
        1023: {
          slidesPerView: 2,
          spaceBetween: 80,
          freeMode: true,
        },
      },
    });
  }
  $('.blog-collection .blog-item').click(function(){
    if($(window).width()>=768){
      var idBlog= $(this).attr('data-id');
      $('.article-feature[data-id='+idBlog+']').show()
      $('.article-feature[data-id='+idBlog+']').siblings('.article-feature').hide();
      $(this).addClass('active');
      $(this).siblings('.blog-item').removeClass('active')
    }
  })
  var ios =navigator.platform
  var isIP=ios.includes("iPhone");
  if(isIP){
    $('body').addClass('is-iphone')
  }
  if($('body').hasClass('is-iphone')){
    $(document).on('keyup keypress', '.input-group__field', function(e) {
      var inval=$(this).val();
      if (inval==""){
        $(this).siblings('.search-placeholder').show()
      }
      else{
        $(this).siblings('.search-placeholder').hide()
      }
    })
  }
  function blogActive(){
    var idBlog=$('.blog-item.swiper-slide-active').attr('data-id')
    $('.list-article-feature .article-feature').hide()
    $('.list-article-feature .article-feature[data-id='+idBlog+']').show()
  } 
  swiperCollection.on('slideChange', function () {
    if($(window).width()<=767 && $('.blog-collection')){
      setTimeout(function(){
        blogActive()
      },100)
    }
  });
})